import { render, staticRenderFns } from "./lessons.vue?vue&type=template&id=ec0d1c2c&scoped=true"
import script from "./lessons.vue?vue&type=script&lang=js"
export * from "./lessons.vue?vue&type=script&lang=js"
import style0 from "./lessons.vue?vue&type=style&index=0&id=ec0d1c2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d1c2c",
  null
  
)

export default component.exports